'use client';

import { c as _c } from "react/compiler-runtime";
import { css } from '@repo/pandacss/css';
import { CloseIcon } from '@repo/ui/icons/CloseIcon';
import { MagnifyIcon } from '@repo/ui/icons/MagnifyIcon';
import { useRef } from 'react';
type Props = {
  id: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  ariaLabel: string;
};
export function Search(t0) {
  const $ = _c(18);
  const {
    id,
    value,
    onChange,
    placeholder,
    ariaLabel
  } = t0;
  const inputRef = useRef(null);
  const hasValue = value.length > 0;
  let t1;
  if ($[0] !== onChange) {
    t1 = () => {
      onChange("");
      inputRef.current?.focus();
    };
    $[0] = onChange;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleClear = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = css({
      position: "relative"
    });
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== onChange) {
    t3 = e => onChange(e.target.value);
    $[3] = onChange;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = css({
      width: "[100%]",
      py: "2",
      pl: "3",
      pr: "5",
      rounded: "md",
      borderWidth: "[1px]",
      borderStyle: "solid",
      borderColor: "neutral.lighter",
      bg: "common.white",
      color: "neutral.darkest",
      textStyle: "body",
      _focus: {
        outline: "[2px solid {colors.blues.focus}]",
        outlineOffset: "[-2px]"
      },
      _placeholder: {
        color: "neutral.dark"
      }
    });
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== ariaLabel || $[7] !== id || $[8] !== placeholder || $[9] !== t3 || $[10] !== value) {
    t5 = <input ref={inputRef} id={id} type="text" value={value} onChange={t3} placeholder={placeholder} aria-label={ariaLabel} className={t4} />;
    $[6] = ariaLabel;
    $[7] = id;
    $[8] = placeholder;
    $[9] = t3;
    $[10] = value;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== handleClear || $[13] !== hasValue) {
    t6 = hasValue ? <button type="button" onClick={handleClear} aria-label="Clear search" className={css({
      position: "absolute",
      right: "3",
      top: "[50%]",
      transform: "[translateY(-50%)]",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "[24px]",
      height: "[24px]",
      p: "[0]",
      border: "none",
      bg: "[transparent]",
      cursor: "pointer",
      color: "neutral.darker",
      rounded: "sm",
      _hover: {
        color: "neutral.darkest"
      }
    })}><CloseIcon className={css({
        width: "[18px]",
        height: "[18px]"
      })} fill="currentColor" /></button> : <span className={css({
      position: "absolute",
      right: "3",
      top: "[50%]",
      transform: "[translateY(-50%)]",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      pointerEvents: "none"
    })} aria-hidden="true"><MagnifyIcon className={css({
        width: "[18px]",
        height: "[18px]"
      })} aria-hidden="true" /></span>;
    $[12] = handleClear;
    $[13] = hasValue;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t5 || $[16] !== t6) {
    t7 = <div className={t2}>{t5}{t6}</div>;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
}